'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chartTooltipWrapper = require('./chart-tooltip-wrapper');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_chartTooltipWrapper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }